import posthog from "posthog-js";

const posthogKey = process.env.REACT_APP_POSTHOG_KEY;

export function initAnalytics() {
  if (!posthogKey || typeof window === "undefined") return;
  // react-snap prerenders every route in headless Chrome at build time; without
  // this the build itself would send a pageview per prerendered page.
  if (navigator.userAgent.includes("ReactSnap")) return;
  posthog.init(posthogKey, {
    api_host: process.env.REACT_APP_POSTHOG_HOST || "https://us.i.posthog.com",
    // SPA routing: posthog patches history itself, no router hook needed.
    capture_pageview: "history_change",
    // Anonymous visitors still send events (pageviews, quiz_start); they just
    // don't get a person profile until they sign in.
    person_profiles: "identified_only",
  });
}

export function trackEvent(name, params = {}) {
  if (typeof window === "undefined") return;
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({ event: name, ...params });
  if (posthogKey) posthog.capture(name, params);
}

export function identifyUser(distinctId, params = {}) {
  if (posthogKey) posthog.identify(distinctId, params);
}

export function resetUser() {
  if (posthogKey) posthog.reset();
}
